import React from "react";
import { Link } from "react-router-dom";
import { ButtonComponent } from "@comps/components";
import { Icon } from "@iconify/react";
import AuthLayout from "./AuthLayout";
import "./auth.css";

/**
 * Shown after a reset link has gone out. The API already tells the caller
 * when an address is not registered (412), so there is nothing to hedge
 * about here — by the time this renders, the account definitely exists.
 */
const RecoverPassword = ({ email, onResend }) => (
  <AuthLayout
    title="Check your email"
    subtitle={
      <>
        We have sent a link to reset your password to{ " " }
        <span className="auth-email">{ email || "your email address" }</span>. The link is
        valid for the next 24 hours.
      </>
    }
    footer={
      <Link className="auth-link auth-back" to="/signin">
        <Icon icon="tabler:arrow-left" width={ 16 } />
        Back to login
      </Link>
    }
  >
    <div className="auth-icon-badge">
      <Icon icon="tabler:mail-check" width={ 28 } />
    </div>

    <ButtonComponent className="actionButton" type="primary" onClick={ onResend }>
      Use a different email
    </ButtonComponent>

    <p className="auth-note">
      Nothing in your inbox? Check the spam folder, and make sure the address you
      entered is the one your account was created with.
    </p>
  </AuthLayout>
);

export default RecoverPassword;
